import RestApiBuilder from '@utils/RestApiBuilder'
import { ApisauceInstance } from 'apisauce'

/**
 * Expose all endponts for 'IAAgent'.
 */
export default <T>(api: ApisauceInstance): ApiObject => ({
    ...RestApiBuilder<T>('reports', api),
    sendMessage: (query: string, tenant: string, session: string, userLogin) => {
        //console.log("API called")
        return api.post(`nlp/query `,
            {
                query: query,
                tenant: tenant,
                session: session,
                userLogin: userLogin
            },
            { headers: {/*'Content-Type': 'application/json',*/ }, })
    },
    sendFeedback: (
        tenant: string,
        session: string,
        item: string,
        userLogin: string,
        rating: number,
        comment: string
    ) => {
        //console.log("API called")
        return api.post(`nlp/feedback `,
            {
                tenant: tenant,
                session: session,
                item: item,
                userLogin: userLogin,
                rating: rating,
                comment: comment
            },
            { headers: {/*'Content-Type': 'application/json',*/ }, })
    },
})

